var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label"},[(_vm.item.isRecommend)?_c('img',{attrs:{"src":require("@/assets/img/common/icon_label_recommend.png"),"alt":"추천"}}):_vm._e(),(_vm.item.isBest)?_c('img',{attrs:{"src":require("@/assets/img/common/icon_label_best.png"),"alt":"인기"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }